import { render, staticRenderFns } from "./photo-group.vue?vue&type=template&id=5df4cfe2&scoped=true&"
import script from "./photo-group.vue?vue&type=script&lang=js&"
export * from "./photo-group.vue?vue&type=script&lang=js&"
import style0 from "./photo-group.vue?vue&type=style&index=0&id=5df4cfe2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df4cfe2",
  null
  
)

export default component.exports